import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/optimized/logo.png";
import { siteInfo } from "../data/siteInfo";
import Icon from "../components/Icon";
import "../css/Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-container footer-grid">
        <div className="footer-brand">
          <Link to="/#home">
            <img
              src={logo}
              alt="Kiddie Kingdom home"
              width="480"
              height="176"
              loading="lazy"
            />
          </Link>
          <p>
            A little kingdom.
            <br />A whole lot of happy memories.
          </p>
          <p>
            Indoor play & birthday parties
            <br />
            in Northridge, California.
          </p>
        </div>
        <nav aria-label="Footer navigation">
          <h2>Come on in</h2>
          <Link to="/#open-play">Open play & memberships</Link>
          <Link to="/packagesdetail">Birthday party packages</Link>
          <Link to="/#gallery">Explore the playground</Link>
          <Link to="/#rules-waiver">Before your visit</Link>
          <Link to="/#waiver">Frequently asked questions</Link>
          <a href={siteInfo.waiver} target="_blank" rel="noopener noreferrer">
            Sign the waiver <Icon name="external" />
          </a>
        </nav>
        <div className="footer-visit">
          <h2>Find your way here</h2>
          <address>
            <a
              href={siteInfo.directions}
              target="_blank"
              rel="noopener noreferrer"
            >
              {siteInfo.address}
            </a>
          </address>
          <a href={siteInfo.phoneHref}>{siteInfo.phone}</a>
          <a className="email-link" href={`mailto:${siteInfo.email}`}>
            {siteInfo.email}
          </a>
          <p>
            Daily · {siteInfo.hours}
            <br />
            <span>
              Open play hours may change for private events. Call before
              visiting.
            </span>
          </p>
          <div className="social-links">
            <a
              href={siteInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram <Icon name="external" />
            </a>
            <a
              href={siteInfo.facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook <Icon name="external" />
            </a>
          </div>
        </div>
      </div>
      <div className="site-container footer-bottom">
        <p>
          © {new Date().getFullYear()} Kiddie Kingdom. All rights reserved.
        </p>
        <Link to="/privacy-policy">Privacy Policy</Link>
      </div>
    </footer>
  );
}
